import { render, staticRenderFns } from "./Fixed.vue?vue&type=template&id=38cab5f6&scoped=true"
import script from "./Fixed.vue?vue&type=script&lang=js"
export * from "./Fixed.vue?vue&type=script&lang=js"
import style0 from "./Fixed.vue?vue&type=style&index=0&id=38cab5f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cab5f6",
  null
  
)

export default component.exports